/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { ChartComponent } from '@swimlane/ngx-charts';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'dash-gis-custom-chart',
    templateUrl: './custom-chart.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('animationState', [
            transition(':enter', [style({ opacity: 0 }), animate('500ms 100ms', style({ opacity: 1 }))]),
        ]),
    ],
})
export class CustomChartComponent extends ChartComponent implements OnChanges {
    @Input() view;
    @Input() showLegend = false;
    @Input() legendOptions: any;

    // remove
    @Input() data;
    @Input() legendData;
    @Input() legendType: any;
    @Input() colors: any;
    @Input() activeEntries: any[];
    @Input() animations = true;

    @Output() legendLabelClick: EventEmitter<any> = new EventEmitter();
    @Output() legendLabelActivate: EventEmitter<any> = new EventEmitter();
    @Output() legendLabelDeactivate: EventEmitter<any> = new EventEmitter();

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }
}
